const ModalHeader = ({ title, content }) => {
  return (
    <div className="flex items-center top-0 bg-white z-10 p-4 border-b">
      <div className="text-lg font-semibold">{title}</div>
      {content && content}
    </div>
  );
};
export default ModalHeader;
